module.exports = __webpack_public_path__ + "static/media/Maf_Cemex.8aacb57e.jpg";